/* eslint-disable no-shadow */
import _ from 'lodash';
import makeImport from '@skyjs/import';
import Collection from '@skyjs/collection';
import makeGetAggregate from './makeGetAggregate.js';
import makeGetAggregateEvents from './getAggregateEvents.js';
import makeGetAffectedAggregateIds from './getAffectedAggregateIds.js';
import makeSendAppRegistrationCode from './sendAppRegistrationCode.js';
import { Language } from '@skyjs/lang';
import dependencies from './dependencies.js';
import makeRenderJsxDataTemplate from './renderJsxDataTemplate.js';

export default function createClientContext(params) {
  const {
    currentUser,
    invokeFunction,
    dependencies: additionalDependencies,
    log,
    isPendingMFA
  } = params;

  // app doit être une nouvelle instance afin de ne pas remplacer la fonction importModule.
  const app = _.clone(params.app);

  const deps = {
    ...additionalDependencies,
    ...dependencies,
    '@skyjs/platform-permissions': Object.freeze(app.permissions)
  };
  app.importModule = makeImport(app.files, deps);

  // Remove the permissions field from the app object as it will be used by the isSolutionCreator && isPlatformDev function only at the moment.
  delete app.permissions;

  const context = {
    app,
    currentUser,
    getAggregate: makeGetAggregate(invokeFunction),
    executeQuery: query => invokeFunction('data-search', { query }),
    createAggregate: params => invokeFunction('data-create', params),
    mutateAggregate: params => invokeFunction('data-mutate', params),
    executeApi: invokeFunction,
    log,
    getFileUrl: (operation, key, filename) => invokeFunction('file', { operation, key, filename }),
    getPublicFileUrl: (operation, key, filename) =>
      invokeFunction('public-file', { operation, key, filename }),
    getAggregateEvents: makeGetAggregateEvents(invokeFunction),
    getAffectedAggregateIds: makeGetAffectedAggregateIds(invokeFunction),
    sendAppRegistrationCode: makeSendAppRegistrationCode(app),
    getEventSubscriptionInfo: () => invokeFunction('event-subscription-info')
  };

  // méthodes exposées seulement en dev
  if (app.version === 'dev') {
    context.importAggregates = (aggregates, options) =>
      invokeFunction('import-aggregates', { aggregates, options });
  }

  // TODO PL : Initialiser Language.
  Language.init(new Collection());

  configureContextByUserland(context);

  context.renderJsxDataTemplate = makeRenderJsxDataTemplate(context);

  context.reset = () => {
    configureContextByUserland(context);
  };

  context.updateApp = () => {
    app.importModule = makeImport(app.files, deps);
    context.reset();
  };

  if (isPendingMFA) {
    context.isPendingMFA = true;
  }

  return context;
}

function configureContextByUserland(context) {
  const { app, log } = context;

  ['@skyjs/data-model/configureContext', '@esm/lang/configureContext']
    .filter(id => _.has(app.files, id))
    .map(id => app.importModule(id))
    .forEach(configureContext => {
      try {
        configureContext(context);
      } catch (err) {
        // eslint-disable-next-line no-debugger
        debugger;
        log.error(err);
      }
    });
}
